<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Experiências</v-toolbar-title>
        <v-spacer></v-spacer>
        <small class="mr-4 text-right">Última atualização:<br/>18/08/2025</small>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
      >
        <template v-slot:item.phone_number="{ item }">
          {{ item.phone_number.substring(1, 100) | phone_number }}
        </template>
        <template v-slot:item.document="{ item }">
          {{ item.document | document }}
        </template>
      </v-data-table>
    </v-container>
  </v-main>
</template>

<script>
import data from './experiencia-usuarios-suporte.json'
import Quicksearch from '@/components/Quicksearch'

export default {
  name: 'experienceUsers',
  components: {
    Quicksearch
  },
  data: () => ({
    loading: false,
    quicksearch: '',
    detailsModal: null,
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        value: 'full_name'
      },
      {
        text: 'E-mail',
        sortable: false,
        value: 'email'
      },
      {
        text: 'Telefone',
        sortable: false,
        value: 'phone_number'
      },
      {
        text: 'CPF',
        sortable: false,
        value: 'document'
      },
      {
        text: 'Login',
        sortable: false,
        value: 'signup_provider'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    }
  }),
  computed: {
    noResultText () {
      return 'Nenhum usuário encontrado'
    },
    filteredItems () {
      return this.items.filter(e => {
        return !this.quicksearch ||
          e.full_name.toLowerCase().search(this.quicksearch) >= 0 ||
          e.email.toLowerCase().search(this.quicksearch) >= 0 ||
          e.phone_number.toLowerCase().search(this.quicksearch) >= 0 ||
          e.document.toLowerCase().search(this.quicksearch) >= 0
      })
    }
  },
  methods: {
    getData () {
      if (data && data.length > 0) {
        console.log(data)
        this.items = [...data]
      } else {
        setTimeout(() => { this.getData() }, 1000)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>
